// 市州渠道对比模块
const state = {
  // 各市州渠道对比
  cityChannelComparison: {
    period: 'today',
    cities: []
  }
}

const mutations = {
  // 设置市州渠道对比数据
  SET_CITY_CHANNEL_COMPARISON(state, data) {
    state.cityChannelComparison = data
  },
  // 重置市州渠道对比数据
  RESET_CITY(state) {
    state.cityChannelComparison = {
      period: 'today',
      cities: []
    }
  }
}

const actions = {
  // 获取各市州渠道对比数据（支持静默刷新）
  async fetchCityChannelComparison({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.cityChannelComparison.period || 'today'
      
      const big = rootState.screen.screenData || {}
      
      // 根据当前区域级别动态获取城市/区县列表
      const getCitiesList = () => {
        const { level, adcode } = rootState.region.currentRegion
        // 使用mapRegion配置获取区县/城市列表
        const { getRegionList } = require('@/components/Modules/mapRegion')
        return getRegionList(adcode, level)
      }
      
      const targetCities = getCitiesList()
      
      // 按周期选择线上/线下源数组
      let onlineArr = []
      let offlineArr = []
      switch (currentPeriod) {
        case 'today':
          onlineArr = Array.isArray(big.qudao_ri_xianshang) ? big.qudao_ri_xianshang : []
          offlineArr = Array.isArray(big.qudao_day_xianxia) ? big.qudao_day_xianxia : []
          break
        case 'week':
          onlineArr = Array.isArray(big.qudao_zhou_xianshang) ? big.qudao_zhou_xianshang : []
          offlineArr = Array.isArray(big.qudao_week_xianxia) ? big.qudao_week_xianxia : []
          break
        case 'month':
        default:
          onlineArr = Array.isArray(big.qudao_yue_xianshang) ? big.qudao_yue_xianshang : []
          offlineArr = Array.isArray(big.qudao_yue_xianxia) ? big.qudao_yue_xianxia : []
          break
      }

      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }

      // 获取城市名称的统一方法
      const nameOf = (item) => String(item?.name || item?.cityName || '').trim()

      // 索引映射便于查找
      const onlineMap = new Map()
      const offlineMap = new Map()
      
      // 处理线上数据 - 使用sl字段
      for (const it of onlineArr) {
        const nm = nameOf(it)
        if (!nm) continue
        const cur = onlineMap.get(nm) || 0
        // 线上数据使用sl字段
        onlineMap.set(nm, cur + safeNum(it?.sl || it?.my || it?.salesAmount || it?.amount || it?.value))
      }
      
      // 处理线下数据 - 使用指定字段
      for (const it of offlineArr) {
        const nm = nameOf(it)  // 获取城市名称
        if (!nm) continue
        const cur = offlineMap.get(nm) || 0
        // 线下数据使用指定的数值字段（根据需求：线下使用name字段对应的数值）
        // 这里的name可能指的是数据中的某个数值字段，不是城市名称
        // 先尝试常见的数值字段
        const value = safeNum(it?.sl || it?.my || it?.salesAmount || it?.amount || it?.value)
        offlineMap.set(nm, cur + value)
      }

      // 确保所有目标地区都有数据输出
      const cities = targetCities.map(cityName => {
        const onlineVal = onlineMap.get(cityName) || 0
        const offlineVal = offlineMap.get(cityName) || 0
        const totalAmount = onlineVal + offlineVal
        return {
          cityName,
          channels: [
            { channelName: '线上', salesAmount: onlineVal },
            { channelName: '线下', salesAmount: offlineVal }
          ],
          totalAmount,
          ranking: 0 // 先占位，后续根据排序赋值
        }
      })

      // 根据总额排序并标注排名
      cities.sort((a, b) => b.totalAmount - a.totalAmount)
      cities.forEach((c, idx) => { c.ranking = idx + 1 })

      commit('SET_CITY_CHANNEL_COMPARISON', { period: currentPeriod, cities })
    } catch (error) {
      console.error('获取市州渠道对比数据失败:', error)
      commit('SET_CITY_CHANNEL_COMPARISON', { period: currentPeriod, cities: [] })
    }
  }
}

const getters = {
  currentCityPeriod: state => state.cityChannelComparison.period,
  cityChannelComparison: state => state.cityChannelComparison
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
